import {Injectable, signal} from '@angular/core';
import {ApiService} from './api/api.service';
import {RealtimeService} from './realtime/realtime.service';
import {Leave, LeaveType} from '../classes/leave';
import {Utils} from '../utils.class';
import {WebsocketService} from './websocket/websocket.service';
import {RealtimeType} from './realtime/realtime-type.enum';
import {formatDate} from '@angular/common';
import {Settings} from '../settings.class';
import {Registration} from '../classes/registration';
import {tap} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class LeaveService {
    static readonly unapprovedLeavesCount = signal<number>(0);

    constructor(public apiService: ApiService, protected websocketService: WebsocketService) {
    }

    getLeaves(history = false, startDate?: Date, endDate?: Date) {
        const fromDate = startDate?.toUTCString() ?? null;
        const toDate = endDate?.toUTCString() ?? null;
        return this.apiService.getCallData$<Leave[]>('leave', {
            ...(this.apiService.buildParams({
                history, fromDate, toDate
            }))
        });
    }

    getLeave(id: number) {
        return this.apiService.getCallData$<Leave>(`leave/${id}`);
    }

    getLeaveRealisations(id: number) {
        return this.apiService.getCallData$<Registration[]>(`leave/realisations/${id}`);
    }

    saveLeave(leave: Leave) {
        return this.apiService.postCall$<Leave>('leave', leave).pipe(tap(() => {
            this.getUnapprovedLeaves().subscribe();
        }));
    }

    approveLeave(id: number) {
        return this.apiService.postCall$<Leave>(`leave/${id}`).pipe(tap(() => {
            this.getUnapprovedLeaves().subscribe();
        }));
    }

    deleteLeave(id) {
        return this.apiService.deleteCall$<Leave>(`leave/${id}`).pipe(tap(() => {
            this.getUnapprovedLeaves().subscribe();
        }));
    }

    getLeaveTypes() {
        return this.apiService.getCallData$<LeaveType[]>('leave/type');
    }

    getUnapprovedLeaves() {
        return this.apiService.getCallData$<number>('leave/unapproved',).pipe(tap(
            (leaves) => {
                LeaveService.unapprovedLeavesCount.set(leaves);
            },));
    }
}
